import type { BattleSide } from '../types/battle';
import { Formation } from './Formation';

export interface BattleResolutionState { winner?: BattleSide; reason?: 'destroyed' | 'routed' | 'withdrawn' | 'objective' | 'timeout'; }

export function resolveBattleWinner(attackers: Formation[], defenders: Formation[], objectiveWinner?: BattleSide, timedOut = false): BattleResolutionState {
  const attackerActive = attackers.filter((formation) => formation.alive && !formation.withdrawn);
  const defenderActive = defenders.filter((formation) => formation.alive && !formation.withdrawn);
  const attackerCombatants = attackerActive.filter((formation) => !formation.routed);
  const defenderCombatants = defenderActive.filter((formation) => !formation.routed);
  if (!attackerActive.length && defenderActive.length) return { winner: 'defender', reason: 'withdrawn' };
  if (!defenderActive.length && attackerActive.length) return { winner: 'attacker', reason: 'withdrawn' };
  if (!attackerActive.length && !defenderActive.length) return { winner: 'defender', reason: 'withdrawn' };
  if (!attackerCombatants.length && defenderCombatants.length) return { winner: 'defender', reason: 'routed' };
  if (!defenderCombatants.length && attackerCombatants.length) return { winner: 'attacker', reason: 'routed' };
  if (objectiveWinner) return { winner: objectiveWinner, reason: 'objective' };
  if (timedOut) return { winner: sideScore(attackers) > sideScore(defenders) * 1.03 ? 'attacker' : 'defender', reason: 'timeout' };
  return {};
}

export function sideScore(formations: Formation[]) {
  return formations.reduce((sum, formation) => sum + formation.combatEffectiveness(), 0);
}
